import React from "react";
import { BadgeCheck } from "lucide-react";

// "Verified" means the player profile has been claimed by an account — this is
// publicPlayer.isClaimed, not a separate moderation flag.
//
// Drawn as a filled badge rather than an outline so it reads at 16px beside a
// player's name, which is the size it appears at in every table row.
const VerifiedTick = ({ className = "", title = "Claimed profile" }) => (
  <span
    // The wrapper carries the size and the icon fills it. Callers pass their
    // own h-/w- classes; only fall back when they don't, since two competing
    // height utilities would be resolved by stylesheet order, not by which
    // one was written last.
    className={`inline-flex shrink-0 text-primary ${
      /\bh-\d/.test(className) ? "" : "h-5 w-5"
    } ${className}`}
    title={title}
    role="img"
    aria-label={title}
  >
    <BadgeCheck
      className="h-full w-full"
      strokeWidth={2}
      fill="currentColor"
      stroke="white"
      aria-hidden="true"
    />
  </span>
);

export default VerifiedTick;
